import './style.css';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import Card from '../Card';
import iconFlecha from '../../assets/icons/icon-flecha.svg';

function ListCard({title, items, path}){
    return <section className="list-card-container">          
        <div className="list-card-header">  
            <h2>{title}</h2>
            <motion.button whileTap={{scale: 0.95}}><Link to={`/${path}`}>Ver todos <img src={iconFlecha}/></Link></motion.button>
        </div>    
        <div className="list-card">
            {items.map(i => <Card item={i} path={path}/>)}        
        </div>
    </section>
}

export default ListCard;